import axiosInstance from '../config/axios.js';

const API_BASE = '/loans/given';

const loanGivenService = {
  // Get base URL for direct downloads
  getBaseUrl: () => {
    return `${axiosInstance.defaults.baseURL}${API_BASE}`;
  },

  // Get all loans with optional filters and pagination
  getAll: async (page = 1, perPage = 10, params = {}) => {
    const queryParams = {
      page,
      per_page: perPage,
      ...params
    };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get loan by ID
  getById: async (loanId) => {
    const response = await axiosInstance.get(`${API_BASE}/${loanId}`);
    return response.data;
  },

  // Get statistics
  getStatistics: async (borrowerType = null, status = null) => {
    const params = {};
    if (borrowerType) params.borrower_type = borrowerType;
    if (status) params.status = status;
    const response = await axiosInstance.get(`${API_BASE}/statistics`, { params });
    return response.data;
  },

  // Get loan types
  getLoanTypes: async () => {
    const response = await axiosInstance.get(`${API_BASE}/types`);
    return response.data;
  },

  // Get borrower types
  getBorrowerTypes: async () => {
    const response = await axiosInstance.get(`${API_BASE}/borrower-types`);
    return response.data;
  },

  // Get repayment frequencies
  getFrequencies: async () => {
    const response = await axiosInstance.get(`${API_BASE}/frequencies`);
    return response.data;
  },

  // Create new loan
  create: async (loanData, agreementDocument = null) => {
    const formData = new FormData();
    
    // Append all loan data
    Object.keys(loanData).forEach(key => {
      if (loanData[key] !== null && loanData[key] !== undefined && loanData[key] !== '') {
        formData.append(key, loanData[key]);
      }
    });

    // Append agreement document if provided
    if (agreementDocument) {
      formData.append('agreement_document', agreementDocument);
    }

    const response = await axiosInstance.post(API_BASE, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Update loan
  update: async (loanId, loanData, agreementDocument = null) => {
    const formData = new FormData();
    
    // Append all loan data
    Object.keys(loanData).forEach(key => {
      if (loanData[key] !== null && loanData[key] !== undefined && loanData[key] !== '') {
        formData.append(key, loanData[key]);
      }
    });

    // Append agreement document if provided
    if (agreementDocument) {
      formData.append('agreement_document', agreementDocument);
    }

    const response = await axiosInstance.put(`${API_BASE}/${loanId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Delete loan
  delete: async (loanId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${loanId}`);
    return response.data;
  },

  // Approve loan
  approve: async (loanId) => {
    const response = await axiosInstance.post(`${API_BASE}/${loanId}/approve`);
    return response.data;
  },

  // Reject loan
  reject: async (loanId, rejectionReason) => {
    const response = await axiosInstance.post(`${API_BASE}/${loanId}/reject`, {
      rejection_reason: rejectionReason
    });
    return response.data;
  },

  // Activate loan
  activate: async (loanId) => {
    const response = await axiosInstance.post(`${API_BASE}/${loanId}/activate`);
    return response.data;
  },

  // Add repayment
  addRepayment: async (loanId, repaymentData, paymentScreenshot = null) => {
    const formData = new FormData();
    
    // Append repayment data
    Object.keys(repaymentData).forEach(key => {
      if (repaymentData[key] !== null && repaymentData[key] !== undefined && repaymentData[key] !== '') {
        formData.append(key, repaymentData[key]);
      }
    });

    // Append payment screenshot if provided
    if (paymentScreenshot) {
      formData.append('payment_screenshot', paymentScreenshot);
    }

    const response = await axiosInstance.post(`${API_BASE}/${loanId}/repayments`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Get agreement document URL
  getAgreementDocument: (loanId) => {
    return `${axiosInstance.defaults.baseURL}${API_BASE}/${loanId}/agreement`;
  }
};

export default loanGivenService;